/*
 * @Author: WUJUN
 * @Date: 2019-10-31 16:05:29
 * @LastEditTime: 2019-10-31 16:06:40
 * @LastEditors: WUJUN
 * @Description: vant 组件
 */
import Vue from 'vue';
import { Toast, Uploader, SwipeCell, Icon, Popup, Field, Picker, Switch, PullRefresh, List, Badge, Skeleton, Tab, Tabs, Stepper } from 'vant';

Vue.use(Toast);
Vue.use(Uploader);
Vue.use(SwipeCell);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Picker);
Vue.use(Switch);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Badge);
Vue.use(Skeleton);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Stepper);



// WEBPACK FOOTER //
// src/utils/vant.js